import { Button } from '@micronet/ui-kit';

interface LoginPageProps {
  onSignIn: () => Promise<void>;
  isSigningIn: boolean;
  error: string | null;
  backgroundSrc: string;
  logoSrc: string;
}

/**
 * Unauthenticated landing screen.
 *
 * Split-screen layout: background image on the left (hidden on mobile) and a
 * centered card on the right with logos and the sign-in button.
 * Rendered directly by the app's login route when `isAuthenticated === false`.
 */
export function LoginPage({ onSignIn, isSigningIn, error, backgroundSrc, logoSrc }: LoginPageProps) {
  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:block lg:w-2/3 relative overflow-hidden">
        <img
          src={backgroundSrc}
          alt="Login Image"
          className="absolute inset-0 h-full w-full object-cover"
        />
      </div>
      <div className="w-full lg:w-1/3 flex items-center justify-center bg-app-slate-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-6 border border-app-slate-200 rounded-lg p-8 shadow-sm bg-white">
          <div className="flex justify-center">
            <img src={logoSrc} alt="App Logo" className="h-auto object-contain" />
          </div>
          
          <div className="flex flex-col gap-5 bg-surface px-8 py-8">
            <Button
             disabled={isSigningIn}
             onClick={() => void onSignIn()}
             className="w-full gap-2"
            >
             {isSigningIn ? (
                <>
                  <Spinner />
                 Iniciando sesión…
                </>
                ) : (
                <>
                Iniciar sesión
                </>
              )}
            </Button>

            {error && (
              <p role="alert" className="text-center text-sm text-destructive">
                {error}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>

  );
}

function Spinner() {
  return (
    <svg
      className="h-4 w-4 animate-spin"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );
}
